import { classNames } from "primereact/utils";
import SmallLoader from "../../loaders/SmallLoader";
import type { ShowOnMapButtonOptions } from "../CardInfoSection";

type ShowOnMapButtonTemplateProps = {
    caption?: string
    buttonOptions: ShowOnMapButtonOptions
}

export function ShowOnMapButtonTemplate({ caption = 'Показать на карте', buttonOptions: { disabled, isLoading, onClick } }: ShowOnMapButtonTemplateProps) {
    const buttonClassnames = classNames({
        "button-div": true,
        "disabled": disabled || isLoading
    })

    return (
        <button disabled={disabled || isLoading} onClick={onClick} className={buttonClassnames}>
            {isLoading ? <SmallLoader text="Загрузка..." /> : <>{caption}</>}
        </button>
    )
}


